import { render, staticRenderFns } from "./DetailsQuitacaoDialog.vue?vue&type=template&id=07af5f80"
import script from "./DetailsQuitacaoDialog.vue?vue&type=script&lang=js"
export * from "./DetailsQuitacaoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports